import React from 'react';
const valueItems = [{
  item: '📘 El Primer Año de tu Bebé — Protocolo B.E.BE 365 (60 páginas)',
  oldValue: '$47',
  newValue: '$6.39'
}, {
  item: '🌙 BONO 1: Noches Doradas',
  oldValue: '$37',
  newValue: '$5'
}, {
  item: '🧠 BONO 2: Pequeño Genio (52 actividades)',
  oldValue: '$27',
  newValue: '$5'
}, {
  item: '📅 BONO 3: Tu Bebé Mes a Mes',
  oldValue: '$19',
  newValue: '$5'
}, {
  item: '💰 BONO 4: Ahorra $2000 en su Primer Año',
  oldValue: '$17',
  newValue: '$5'
}];
interface ValueStackSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function ValueStackSection({
  onBuyClick
}: ValueStackSectionProps) {
  const handleScrollToBonuses = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector('#bonuses');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5" data-id="element-428">
      <div className="max-w-[900px] mx-auto" data-id="element-429">
        <div className="text-center mb-10" data-id="element-430">
          <span className="inline-block bg-white/10 text-[#C9A96E] text-xs tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-431">
            Todo lo que puedes obtener hoy
          </span>
          <h2 className="text-3xl md:text-4xl text-[#FAF7F2] leading-tight" data-id="element-432">
            El Paquete Completo B.E.BE 365
          </h2>
        </div>

        <table className="w-full border-collapse mb-10" data-id="element-433">
          <tbody data-id="element-434">
            {valueItems.map((item, idx) => <tr key={idx} className="border-b border-white/10 last:border-b-0" data-id="element-435">
                <td className="py-4 px-3 font-sans text-base text-[rgba(250,247,242,0.9)]" data-id="element-436">
                  {item.item}
                </td>
                <td className="py-4 px-3 text-right" data-id="element-437">
                  <span className="text-sm text-[rgba(250,247,242,0.4)] line-through mr-2 font-sans" data-id="element-438">
                    {item.oldValue}
                  </span>
                  <span className="text-base text-[#C9A96E] font-bold font-sans" data-id="element-439">
                    {item.newValue}
                  </span>
                </td>
              </tr>)}
            <tr className="border-t-2 border-[rgba(183,110,121,0.4)]" data-id="element-440">
              <td className="pt-5 px-3 font-sans text-lg text-[#FAF7F2] font-bold" data-id="element-441">
                💎 VALOR TOTAL
              </td>
              <td className="pt-5 px-3 text-right" data-id="element-442">
                <span className="text-base text-[rgba(250,247,242,0.4)] line-through mr-2 font-sans" data-id="element-443">
                  $147
                </span>
                <span className="text-lg text-[#FAF7F2] font-bold font-sans" data-id="element-444">
                  $26.39
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="bg-white/5 rounded-3xl p-9 border border-[rgba(183,110,121,0.3)] text-center" data-id="element-445">
          <div className="text-xl text-[rgba(250,247,242,0.5)] line-through mb-2 font-sans" data-id="element-446">
            Valor total: $147
          </div>
          <div className="text-6xl md:text-7xl font-bold text-[#FAF7F2] leading-none mb-1.5" data-id="element-447">
            $13.20
          </div>
          <a href="https://betterdailyguides.com/cart/51947128750382:1" className="inline-block bg-[#B76E79] text-white text-base font-bold px-4 py-1.5 rounded-full mb-5 font-sans hover:bg-[#a25d67] transition-colors no-underline" data-id="element-448">
            💰 LLEVA TODO CON 50% OFF ADICIONAL
          </a>

          <p className="text-base text-[rgba(250,247,242,0.75)] font-sans leading-relaxed max-w-[520px] mx-auto mb-3 italic" data-id="element-449">
            ¿Por qué tan económico? Porque estamos en nuestro lanzamiento
            fundacional 2026. Buscamos a nuestras primeras 500 familias para que
            experimenten el protocolo completo, compartan sus resultados y nos
            ayuden a crecer. Una vez que alcancemos los 500 miembros, este
            precio se cerrará permanentemente.
          </p>

          <p className="text-base text-[#FAF7F2] font-sans font-bold mb-6" data-id="element-450">
            No estás obteniendo un descuento. Estás obteniendo acceso de miembro
            fundador.
          </p>

          <a href="https://betterdailyguides.com/cart/51947128750382:1" className="inline-block bg-gradient-to-r from-[#C9A96E] to-[#B76E79] text-white text-lg font-bold py-5 px-12 rounded-full tracking-wide shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse" data-id="element-451">
            ⚡ SÍ, QUIERO PERSONALIZAR MI PAQUETE →
          </a>

          <div className="flex justify-center gap-5 flex-wrap mt-5 text-sm text-[rgba(250,247,242,0.6)] font-sans" data-id="element-452">
            <span className="flex items-center gap-1.5" data-id="element-453">
              🔒 Pago Seguro SSL
            </span>
            <span className="flex items-center gap-1.5" data-id="element-454">
              📥 Acceso Inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-455">
              ↩️ Garantía de 30 Días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-456">
              💳 Visa · PayPal · Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}